import styled from 'styled-components';

export const StyledHeader = styled.div`
  display: flex;
  gap: 12px;
  align-items: center;
  padding: 16px 20px;
  border-bottom: 1px solid ${({ theme }) => theme.color.grey88};
`;

export const StyledAvatar = styled.div`
  display: flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  background-color: ${({ theme }) => theme.color.violet96};
  border-radius: 50%;
`;

export const StyledIcon = styled.img`
  display: block;
  width: 24px;
  height: 24px;
  object-fit: contain;
`;

export const StyledTitles = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
`;

export const StyledTitle = styled.div`
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: ${({ theme }) => theme.size.gollum};
  font-weight: ${({ theme }) => theme.weight.semibold};
  white-space: nowrap;
`;

export const StyledSubtitle = styled.div`
  font-size: ${({ theme }) => theme.size.ring};
  color: ${({ theme }) => theme.color.grey52};
`;

export const StyledClose = styled.button`
  display: flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  padding: 0;
  cursor: pointer;
  background: none;
  border: none;
  border-radius: 8px;
  transition: background-color 200ms linear;

  &:hover {
    background-color: ${({ theme }) => theme.color.grey95};
  }
`;
